import { __rest } from "tslib";
import React, { createContext, useContext, useEffect, useState } from 'react';
import { findKey } from 'lodash-es';
import dayjs from 'dayjs';
// 如果用到其他 dayjs 语言包在外部需要自己引入
import 'dayjs/locale/zh-cn';
const ZH = 'zh';
const defaultLangConfig = {
    zh: ['zh', 'zh-CN', 'zh-SG'],
    en: ['en', 'en-US'],
};
const LocaleContext = createContext(null);
export const LocaleContextProvider = (_a) => {
    var _b, _c;
    var { languageChangeCallback, langList = [], langConfig = defaultLangConfig, detectLang, specifiedLang } = _a, rest = __rest(_a, ["languageChangeCallback", "langList", "langConfig", "detectLang", "specifiedLang"]);
    const detectLanguage = detectLang ? (_b = findKey(langConfig, item => item.includes(detectLang))) !== null && _b !== void 0 ? _b : detectLang : undefined;
    const initLang = (_c = (specifiedLang || detectLanguage)) !== null && _c !== void 0 ? _c : ZH;
    const [language, setLanguage] = useState(initLang);
    // 设置初始化，将 localStorage 及 dayjs 的语言环境都初始化同步为检测到的语言环境
    useEffect(() => {
        changeLanguage(initLang);
    }, []);
    // 只改变 antd 的 dayjs 的语言包依赖和在 localStorage 中存储了国际化标识，导出的 language 可以在 antd 提供的 ConfigProvider 使用
    // 另外也可以不使用导出的 language 使用其他不仅仅针对 antd 的国际化框架，如 https://react.i18next.com/getting-started
    const changeLanguage = (lang) => {
        setLanguage(lang);
        dayjs.locale(lang);
        languageChangeCallback && languageChangeCallback(lang);
    };
    return (React.createElement(LocaleContext.Provider, Object.assign({ value: {
            langList,
            language: language || initLang,
            detectLang: detectLanguage,
            changeLanguage,
        } }, rest)));
};
function useAntLocale() {
    const context = useContext(LocaleContext);
    if (!context) {
        throw new Error(`请在组件外使用LocaleContextProvider`);
    }
    return context;
}
export default useAntLocale;
//# sourceMappingURL=index.js.map